const env = process.env.NODE_ENV;

let base = ''
if(env=='development'){/* 开发环境 */
    base = 'https://adqunar.qunar.com/adperiapi/'
}else if(env=='beta'){/* beta环境 */
    base = 'http://adperi.beta.qunar.com/api/'
}else{/* 默认为生产环境 */
    base = '/adperiapi/'
}

export const baseUrl = base;